import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { moduleName } from './constants'
import { RejectedInvoicesState } from './types'
import {
  RejectedInvoice,
  RejectedInvoiceLine
} from '../../../features/InvoiceData/RejectedInvoices/types'
import { ResponseWithPagination } from '../../../constants'

const initialState: RejectedInvoicesState = {
  changedLines: [],
  search: null,
  list: [],
  total: 0,
  isLoading: false,
  isLoaded: false,
  rejectedAmount: 0
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    loading(state: RejectedInvoicesState) {
      state.isLoading = true
    },
    finish(state: RejectedInvoicesState) {
      state.isLoading = false
    },
    set(
      state: RejectedInvoicesState,
      action: PayloadAction<
        ResponseWithPagination<RejectedInvoice> &
          Pick<RejectedInvoicesState, 'search'>
      >
    ) {
      state.search = action.payload.search
      state.list = action.payload.results
      state.total = action.payload.count
    },
    bulk(
      state: RejectedInvoicesState,
      action: PayloadAction<RejectedInvoice[]>
    ) {
      state.list = [...state.list, ...action.payload]
    },
    reset(state: RejectedInvoicesState) {
      Object.keys(initialState).forEach((key) => {
        state[key as string] = initialState[key]
      })
    },
    setChangedLines: (
      state: RejectedInvoicesState,
      action: PayloadAction<RejectedInvoiceLine[]>
    ) => {
      state.changedLines = action.payload
    },
    setRejectedAmount: (
      state: RejectedInvoicesState,
      action: PayloadAction<number>
    ) => {
      state.rejectedAmount = action.payload
    }
  }
})

export default slice.reducer
export const {
  setChangedLines,
  loading,
  finish,
  set,
  bulk,
  reset,
  setRejectedAmount
} = slice.actions
